export default __webpack_public_path__ + "static/eib-cagnes-ecole-internationale-flags-364bc226117c1f15f642bc9dd63ff914.png";